import listenForResponseOnVoice from './listenForResponseOnVoice';

export default listenForResponseOnVoice;
